import React from "react";
import { AutocompleteOption } from "@miplatform/components";
import { ENTITY_NAMES } from "@miplatform/constants";
import { FilterSidebar } from "@mibuildweb/components";
import { BidFilter } from "../types";

export const groupByOptions = [
  { label: "None", value: "None" },
  { label: ENTITY_NAMES.BID_REQUEST, value: "bidRequestId" },
  { label: "Builder", value: "builderId" },
  { label: "Community", value: "communityId" },
  { label: "Series Group", value: "seriesGroupId" },
  { label: "Series", value: "seriesId" },
];

export const sortByOptions = [
  { label: "None", value: "None" },
  { label: "Due Date (Desc.)", value: "dueDate desc" },
  { label: "Due Date (Asc.)", value: "dueDate asc" },
  { label: "Request Date (Desc.)", value: "requestDate desc" },
  { label: "Request Date (Asc.)", value: "requestDate asc" },
  { label: "Last Updated (Desc.)", value: "modifiedOn desc" },
  { label: "Last Updated (Asc.)", value: "modifiedOn asc" },
];

const AUTOCOMPLETE_FIELD_MAP = {
  BUILDER_ID: "builderId",
  COMMUNITY_ID: "communityId",
  SERIES_GROUP_ID: "seriesGroupId",
  SERIES_ID: "seriesId",
  ASSIGNEE_ID: "assigneeId",
  PLAN_STATUS: "planStatus",
};

export const initialBidFilters: BidFilter = {
  groupBy: "bidRequestId",
  sortBy: "modifiedOn desc",
  builderId: "All",
  communityId: "All",
  seriesGroupId: "All",
  seriesId: "All",
  assigneeId: "All",
  planStatus: "All",
};

export const BidFilterSidebar: React.FC<BidFilterSidebarProps> = ({
  builderOptions,
  communityOptions,
  seriesGroupOptions,
  seriesOptions,
  assigneeOptions,
  planStatusOptions,
  filters,
  onApplyFilters,
  resetFilters,
  loading,
}) => {
  const bidDataFilters = {
    [AUTOCOMPLETE_FIELD_MAP.BUILDER_ID]: {
      field: AUTOCOMPLETE_FIELD_MAP.BUILDER_ID,
      label: "Builder",
      data: builderOptions,
    },
    [AUTOCOMPLETE_FIELD_MAP.COMMUNITY_ID]: {
      field: AUTOCOMPLETE_FIELD_MAP.COMMUNITY_ID,
      label: "Community",
      data: communityOptions,
    },
    [AUTOCOMPLETE_FIELD_MAP.SERIES_GROUP_ID]: {
      field: AUTOCOMPLETE_FIELD_MAP.SERIES_GROUP_ID,
      label: "Series Group",
      data: seriesGroupOptions,
    },
    [AUTOCOMPLETE_FIELD_MAP.SERIES_ID]: {
      field: AUTOCOMPLETE_FIELD_MAP.SERIES_ID,
      label: "Series",
      data: seriesOptions,
    },
    [AUTOCOMPLETE_FIELD_MAP.ASSIGNEE_ID]: {
      field: AUTOCOMPLETE_FIELD_MAP.ASSIGNEE_ID,
      label: "Assignee",
      data: assigneeOptions,
    },
    [AUTOCOMPLETE_FIELD_MAP.PLAN_STATUS]: {
      field: AUTOCOMPLETE_FIELD_MAP.PLAN_STATUS,
      label: "Bid Status",
      data: planStatusOptions, // Replace with actual plan status options if available
    },
  };

  return (
    <FilterSidebar
      filters={filters}
      initialFilters={initialBidFilters}
      onApplyFilters={onApplyFilters}
      onResetFilters={resetFilters}
      groupByOptions={groupByOptions}
      sortByOptions={sortByOptions}
      dataFilters={bidDataFilters}
      loading={loading}
      enableSearchParamsSync
    />
  );
};

type BidFilterSidebarProps = {
  builderOptions: AutocompleteOption[];
  communityOptions: AutocompleteOption[];
  seriesGroupOptions: AutocompleteOption[];
  seriesOptions: AutocompleteOption[];
  assigneeOptions: AutocompleteOption[];
  planStatusOptions: AutocompleteOption[];
  filters: BidFilter;
  onApplyFilters: (filters: BidFilter) => void;
  resetFilters?: () => void;
  loading?: boolean;
};
